import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M25 20.5a4.5 4.5 0 0 0-3.182 1.318 4.5 4.5 0 0 0 0 6.364L43.637 50 21.818 71.818a4.5 4.5 0 0 0 0 6.364 4.5 4.5 0 0 0 6.364 0L50 56.363l21.818 21.819a4.5 4.5 0 0 0 6.364 0 4.5 4.5 0 0 0 0-6.364L56.363 50l21.819-21.818a4.5 4.5 0 0 0 0-6.364A4.5 4.5 0 0 0 75 20.5a4.5 4.5 0 0 0-3.182 1.318L50 43.637 28.182 21.818A4.5 4.5 0 0 0 25 20.5" />
  </svg>
);
const ForwardRef = forwardRef(SvgCross);
export default ForwardRef;
